import { CSSProperties, FC, useMemo } from 'react';

const widthCoef = 0.68;

export interface CarIconProps {
  placeId: string;
  height: number;
  rotation: number;
  containerClassName?: string;
  carClassName?: string;
}

export const CarIcon: FC<CarIconProps> = ({
  placeId,
  height,
  rotation,
  containerClassName,
  carClassName,
}) => {
  const width = height * widthCoef;

  const svgStyle = useMemo(
    (): CSSProperties => ({
      transform: `rotate(${rotation}deg)`,
    }),
    [rotation],
  );

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 733.041 1038.48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      data-place-id={placeId}
      className={containerClassName}
      style={svgStyle}
    >
      <path
        id='Основание'
        d='M239.85 0L493.18 0C586.29 0 661.77 75.48 661.77 168.59L661.77 869.88C661.77 962.99 586.29 1038.48 493.18 1038.48L239.85 1038.48C146.74 1038.48 71.26 962.99 71.26 869.88L71.26 168.59C71.26 75.48 146.74 0 239.85 0Z'
        className={carClassName}
        data-place-id={placeId}
      />
      <path
        id='Зеркало'
        d='M661.77 407.24L712.67 407.24C723.92 407.24 733.04 398.12 733.04 386.88C733.04 347.52 701.13 315.61 661.77 315.61L661.77 407.24Z'
        className={carClassName}
        data-place-id={placeId}
      />
      <path
        id='Зеркало'
        d='M71.26 407.24L20.36 407.24C9.11 407.24 0 398.12 0 386.88C0 347.52 31.9 315.61 71.26 315.61L71.26 407.24Z'
        className={carClassName}
        data-place-id={placeId}
      />
      <path
        id='Лобовое'
        d='M545.04 320.54L533.59 335.29C523.65 348.09 507.1 353.83 491.37 349.93C410.17 329.84 325.37 329.26 243.91 348.24L237.61 349.7C220.43 353.71 202.54 346.83 192.47 332.34L183.29 319.13C165.79 293.95 169.67 259.71 192.34 239.08L196.85 234.98C229.28 205.48 268.84 184.95 311.63 175.42L312.57 175.21C348.95 167.1 386.69 167.31 422.97 175.81C462.63 185.1 499.39 204.03 529.99 230.91L537.12 237.18C561.39 258.5 564.86 295.03 545.04 320.54Z'
        fill='#191C34'
        fillOpacity='0.120000'
        fillRule='evenodd'
        data-place-id={placeId}
      />
      <path
        id='Заднее'
        d='M555.98 833.82L524.77 793.64C520.19 787.74 512.57 785.1 505.32 786.89C414.95 809.26 320.58 809.9 229.91 788.78L222.32 787.01C214.37 785.16 206.09 788.34 201.43 795.04L173.81 834.79C161.74 852.16 164.41 875.79 180.06 890.02L196.85 905.3C229.28 934.8 268.84 955.33 311.63 964.86L312.57 965.07C348.95 973.18 386.69 972.97 422.97 964.47C462.63 955.18 499.39 936.25 529.99 909.37L550.51 891.33C567.26 876.62 569.65 851.42 555.98 833.82Z'
        fill='#191C34'
        fillOpacity='0.120000'
        fillRule='evenodd'
        data-place-id={placeId}
      />
      <path
        id='Фара'
        d='M194.04 61.08C199.33 61.08 203.62 65.37 203.62 70.66L203.62 115.38C203.62 130.38 191.46 142.53 176.47 142.53L131.75 142.53C126.46 142.53 122.17 138.24 122.17 132.95C122.17 93.26 154.34 61.08 194.04 61.08Z'
        fill='#191C34'
        fillOpacity='0.120000'
        fillRule='evenodd'
        data-place-id={placeId}
      />
      <path
        id='Фара'
        d='M539 61.08C533.7 61.08 529.41 65.37 529.41 70.66L529.41 115.38C529.41 130.38 541.57 142.53 556.56 142.53L601.28 142.53C606.57 142.53 610.86 138.24 610.86 132.95C610.86 93.26 578.69 61.08 539 61.08Z'
        fill='#191C34'
        fillOpacity='0.120000'
        fillRule='evenodd'
        data-place-id={placeId}
      />
    </svg>
  );
};
